import { EMPTY } from 'rxjs';
import { PromptElementImplInterface } from './PromptElementImplInterface';
import { UnknownState } from '@sas-dvr/internal-va-react-core/store/birdElement/unknownState';

export class UnknownImpl implements PromptElementImplInterface {
  private _id: string;

  constructor(id: string) {
    this._id = id;
  }

  createElement() {
    return UnknownState.actions.add(this._id, {});
  }

  deleteElement() {
    return UnknownState.actions.delete(this._id);
  }

  handleDataChange() {
    return EMPTY;
  }

  handleValueChanged() {
    return EMPTY;
  }

  handleActions() {
    return EMPTY;
  }
}
